import { Button } from '@/components';
import { useMessage } from '@/providers';
import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDownloadOrganizationListCsv } from '../_hooks/organization';

export const DownloadOrganizationListCsvButton: FC = () => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const { mutateAsync: downloadOrganizationListCsv, isPending } =
    useDownloadOrganizationListCsv();

  const download = useCallback(async () => {
    try {
      await downloadOrganizationListCsv();
      await openMessage(
        'success',
        t('export-file-requested', {
          target: t('export-csv-file', {
            target: t('organization-list'),
          }),
        }),
      );
    } catch {
      await openMessage('error', t('error-message-csv-download'));
    }
  }, [downloadOrganizationListCsv, openMessage, t]);

  return (
    <Button onClick={download} loading={isPending}>
      {t('csv-download')}
    </Button>
  );
};
